export const JOIN_CLASS_PARAM = 'joinClass';
